import bulkUpload, {
	initialState as initialStateBulkUpload,
} from './bulkUpload.reducer';
import companySettings, {
	initialState as initialCompanySettings,
} from './companySettings.reducer';
import configurations, {
	initialState as initialConfigurations,
} from './configurations';
import editSensorData, {
	initialState as initialSensorData,
} from './editSensorData.reducer';
import heartBeatDetails, {
	initialState as initialHeartBeatDetails,
} from './heartBeatDetails';
import imagePath, {
	initialState as initialImagesPathes,
} from './images.reducer';
import implementation, {
	initialState as implementationInitialState,
} from './implementation.reducer';
import {
	initialIntegration,
	integrationsReducer,
} from '../features/IntegrationsTab/integrations/reducers';
import mapManagement, {
	initialState as initialMapManagement,
} from './mapManagement.reducer';
import navigate, {
	initialState as initialNavigateStore,
} from './navigate.reducer';
import physicalSensorCount, {
	initialState as physicalSensorCountState,
} from './physicalSensors.reducer';
import products, { initialState as initialProducts } from './products';
import schedules, { initialState as schedulesState } from './schedules.reducer';
import sensorDetails, {
	initialState as initialSensorDetails,
} from './sensorDetails';
import sensorGroup, {
	initialState as initialSensorGroup,
} from './sensorGroup.reducer';
import sensorTypes, { initialState as initialSensorTypes } from './sensorTypes';
import sensors, { initialState as initialSensors } from './sensors';
import stations, { initialState as initialStations } from './stations.reducer';
import systemConnections, {
	initialState as initialSystemConnections,
} from './systemConnections';
import tiling, { initialState as initialStateTiling } from './tiling.reducer';
import users, { initialState as initialUsers } from './users';
import valueMappingProfiles, {
	initialState as valueMappingProfilesInitialState,
} from './valueMapping';
import virtualSensorCount, {
	initialState as virtualSensorCountState,
} from './virtualSensors.reducer';
import tenantStack, {
	initialState as tenantStackInitialState,
} from './tenantStack';

import { StoreState } from '@Types';
import { combineReducers } from 'redux';
import { moduleNamespace } from '@Store/config.store';

// plop - import reducer here

export const initialState: StoreState = {
	users: initialUsers,
	products: initialProducts,
	systemConnections: initialSystemConnections,
	configurations: initialConfigurations,
	companySettings: initialCompanySettings,
	sensors: initialSensors,
	sensorTypes: initialSensorTypes,
	sensorDetails: initialSensorDetails,
	heartBeatDetails: initialHeartBeatDetails,
	navigate: initialNavigateStore,
	editSensorData: initialSensorData,
	implementation: implementationInitialState,
	valueMappingProfiles: valueMappingProfilesInitialState,
	sensorGroup: initialSensorGroup,
	stations: initialStations,
	imagePath: initialImagesPathes,
	virtualSensorCount: virtualSensorCountState,
	physicalSensorCount: physicalSensorCountState,
	integrations: initialIntegration,
	schedules: schedulesState,
	mapManagement: initialMapManagement,
	bulkUpload: initialStateBulkUpload,
	tiling: initialStateTiling,
	tenantStack: tenantStackInitialState,
	// plop - add default reducer state here
};

export default combineReducers({
	users,
	products,
	systemConnections,
	configurations,
	companySettings,
	sensors,
	sensorTypes,
	sensorDetails,
	heartBeatDetails,
	navigate,
	editSensorData,
	implementation,
	valueMappingProfiles,
	sensorGroup,
	stations,
	imagePath,
	virtualSensorCount,
	physicalSensorCount,
	integrations: integrationsReducer,
	schedules,
	mapManagement,
	bulkUpload,
	tiling,
	tenantStack,
	// plop - add reducer key here
});

export const reducerKey = moduleNamespace;
